import { render, staticRenderFns } from "./Saas.vue?vue&type=template&id=05028220&"
import script from "./Saas.vue?vue&type=script&lang=js&"
export * from "./Saas.vue?vue&type=script&lang=js&"
import style0 from "./Saas.vue?vue&type=style&index=0&id=05028220&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports